import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HermesService } from './hermes.service';
import {
  FarmaIaMetadataResponse,
  FarmaIaCostDashboardResponse,
  FarmaIaReportingQuery,
  FarmaIaTrainingEntry,
  TrainingUpdateRequest,
  UsageDataEntry
} from '../models/interfaz';

/**
 * @deprecated Utilizar HermesService en src/app/@core/services/hermes.service.ts
 */
@Injectable({
  providedIn: 'root'
})
export class FarmaIaService {
  constructor(private hermesService: HermesService) {}

  getFarmaIaMetadata(query: FarmaIaReportingQuery = {}): Observable<FarmaIaMetadataResponse> {
    return this.hermesService.getMetadata(query);
  }

  getFarmaIaCostDashboard(query: FarmaIaReportingQuery = {}): Observable<FarmaIaCostDashboardResponse> {
    return this.hermesService.getCostDashboard(query);
  }

  getFarmaIaTrainingData(): Observable<FarmaIaTrainingEntry[]> {
    return this.hermesService.getTrainingData();
  }

  async updateSQLTraining(data: TrainingUpdateRequest): Promise<void> {
    await this.hermesService.updateSQLTraining(data);
  }

  embedFarmaIATraining(): Observable<unknown> {
    return this.hermesService.embedTraining();
  }

  getUsageData(): Observable<UsageDataEntry[]> {
    return this.hermesService.getUsageData();
  }
}
